import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

const MyMenu = ({ id, anchorEl, open, onClose, row, onAction }) => {
  const handleMenuItemClick = (option) => {
    if (onAction) {
      onAction(option);
    }
    onClose();
  };

  return (
    <Menu
      id={id}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <MenuItem onClick={() => handleMenuItemClick("view_onboarded")}>
        View users onboard
      </MenuItem>
      <MenuItem onClick={() => handleMenuItemClick("delete")}>
        Delete User
      </MenuItem>
      <MenuItem onClick={() => handleMenuItemClick(row?.active ? "deactivate" : "activate")}>
        {row?.active ? "Deactivate User" : "Activate User"}
      </MenuItem>
      <MenuItem onClick={() => handleMenuItemClick("regenerate_password")}>
        Regenerate Password
      </MenuItem>
      <MenuItem onClick={() => handleMenuItemClick("update")}>
        Update Marketer
      </MenuItem>
      <MenuItem onClick={() => handleMenuItemClick("resend_otp")}>
        Resend OTP
      </MenuItem>
    </Menu>
  );
};

export default MyMenu;
